import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    width: "65",
    height: "65",
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<g opacity=".96" fill="#1A3446"> <path d="M32.5019 6.0156a26.3758 26.3758 0 0 0-.6816 52.7386h.0298l21.979-.1789a5.0571 5.0571 0 0 0 5.0485-5.0528V32.3913A26.4144 26.4144 0 0 0 32.5019 6.0156Zm22.8055 47.5069a1.4863 1.4863 0 0 1-.9247 1.3723 1.4881 1.4881 0 0 1-.5706.1103l-21.9322.1789a22.8054 22.8054 0 1 1 23.4318-22.7927l-.0043 21.1312Z"/> <path d="M32.5019 17.834c-.4735 0-.9275.1881-1.2623.5228a1.7854 1.7854 0 0 0-.5228 1.2623v19.7338a1.7852 1.7852 0 0 0 3.5702 0V19.6191a1.7897 1.7897 0 0 0-1.7851-1.7851ZM32.506 46.8129c.9812 0 1.7766-.7954 1.7766-1.7766 0-.9811-.7954-1.7765-1.7766-1.7765-.9811 0-1.7765.7954-1.7765 1.7765 0 .9812.7954 1.7766 1.7765 1.7766Z"/> </g>' }
  })
);